(() => {
    console.log('%c👍🏼 Hero Video Zoom', 'color: yellow');
    const section = document.querySelector('.hero-video-zoom');
    const video = section.querySelector('video');
    const videoTextContainer = section.querySelector('.hero-video-zoom__video-text-container');
    const videoContainer = section.querySelector('.hero-video-zoom__container');
    const videoTitle = section.querySelector('[data-slide-in-from]');
    const videoBlurb = section.querySelector('.hero-video-zoom__blurb');
    const spinIcon = section.querySelector('.hero-video-zoom__spin-icon');
    const cta = section.querySelector('.hero-video-zoom__cta');
    let videoIsZoomed = false;

    video.parentElement.addEventListener('click', (event) => {
        if (!videoIsZoomed) {
            event.preventDefault();
            showVideo();
            videoIsZoomed = true;
        } else {
            hideVideo();
            videoIsZoomed = false;
        }
    });

    const addHoverListener = () => {
        video.parentElement.addEventListener('mouseenter', () => {
            if (videoIsZoomed || window.innerWidth < 768) {
                return;
            }

            const videoBoundingBox = video.getBoundingClientRect();
            const videoWidth = videoBoundingBox.width;
            spinIcon.style.left = `${video.offsetLeft + (videoWidth / 2)}px`;
            spinIcon.style.display = 'block';

            setTimeout(() => {
                requestAnimationFrame(() => {
                    spinIcon.style.opacity = 1;
                });
            }, 100);
        });

        video.parentElement.addEventListener('mouseleave', () => {
            spinIcon.style.opacity = 0;
            setTimeout(() => {
                spinIcon.style.display = 'none';
            }, 500);
        });
    };

    const hideVideo = () => {
        if (window.innerWidth < 768) {
            return;
        }

        const parent = videoTextContainer;
        video.muted = true;
        video.removeAttribute('controls');

        cta.classList.remove(cta.getAttribute('data-expanded-classes').split(' '));

        requestAnimationFrame(() => {
            // animate parent to an aspect ratio of 16:9
            parent.style.paddingTop = '0';
            video.style.opacity = 0;

            videoTitle.classList.remove('opacity-0', '-translate-x-[50vw]');
            videoBlurb.classList.remove('opacity-0', 'translate-x-[50vw]');
            videoContainer.classList.remove('!pt-0');
            video.style.width = '';
            video.style.height = '';

            setTimeout(() => {
                requestAnimationFrame(() => {                    
                    video.style.position = 'unset';
                    video.style.opacity = 1;
                })
            }, 1000);
        });
    }

    const playVideo = () => {
        video.setAttribute('controls', true);
        video.currentTime = 0;
        video.muted = false;

        video.play();
    };

    const showVideo = () => {
        // if mobile, don't zoom
        if (window.innerWidth < 768) {
            playVideo();
            spinIcon.style.opacity = 0;
            return;
        }

        const parent = videoTextContainer;

        spinIcon.style.display = 'none';
        cta.classList.add(cta.getAttribute('data-expanded-classes').split(' '));

        // get the parent's bounding box
        const parentBoundingBox = parent.getBoundingClientRect();
        const parentTop = parentBoundingBox.top;
        const parentLeft = parentBoundingBox.left;

        // get the video's bounding box
        const videoBoundingBox = video.getBoundingClientRect();
        const videoTop = videoBoundingBox.top;
        const videoLeft = videoBoundingBox.left;
        const videoWidth = videoBoundingBox.width;
        const videoHeight = videoBoundingBox.height;

        // calculate the new position relative to the parent
        const newTop = videoTop - parentTop;
        const newLeft = videoLeft - parentLeft;

        // update video position and set to absolute
        video.style.display = 'none';
        video.style.opacity = 0;

        videoTitle.classList.add('opacity-0', '-translate-x-[50vw]');
        videoBlurb.classList.add('opacity-0', 'translate-x-[50vw]');
        videoContainer.classList.add('!pt-0')
        playVideo();

        requestAnimationFrame(() => {
            // animate parent to an aspect ratio of 16:9
            parent.style.paddingTop = '56.25%';

            video.style.position = 'absolute';
            video.style.top = `${newTop}px`;
            video.style.left = `${newLeft}px`;
            video.style.width = `${videoWidth}px`;
            video.style.height = `${videoHeight}px`;
            video.style.display = 'block';
            video.style.opacity = 1;

            requestAnimationFrame(() => {
                video.style.top = '0';
                video.style.left = '0';
                video.style.width = '100%';
                video.style.height = 'auto';
            });
        });
    };

    addHoverListener();

    const addObservers = () => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) {
                    video.pause();
                }
            });
        }, {
            root: null, // use the viewport as the root
            rootMargin: '0px', // no margin around the root
            threshold: 0 // trigger when 30% of the section is in view
        });
    
        observer.observe(section);
    };

    addObservers();
})();